import Vue from 'vue';
import http from '@/assets/js/http';
let baseCmrUrl = window.BaseConfigInfo.baseSSO.domainNameCmr
const cmr = {
  // 判断字符是否为空的方法
  isEmpty(obj) {
    if (typeof obj == "undefined" || obj == null || obj === "") {
      return true;
    } else {
      return false;
    }
  },
  // 筛选有权限的数组
  filterPermissions(permissions, functionKey) {
    const res = [];

    permissions.forEach(permission => {
      const tmp = { ...permission }
      if (tmp.children) {
        tmp.children = this.filterPermissions(tmp.children, functionKey);
      } else {
        if (tmp.functionKey && tmp.functionKey === functionKey) {
          res.push(tmp)
        } 
      }
      if (tmp.hasOwnProperty("children") && tmp.children && tmp.children.length > 0) {
        res.push(tmp)
      }
    })

    return res;
  },
  /*
  * 根据数组对象属性删除对应项
  * @param {Array} arr - 数组对象
  * @param {String} attr - 属性
  * @param {} value - 属性值
  * @return void
  */
  removeFromArrayByAttr(arr, attr, value)
  { 
    var index=0;
    for(var i in arr){
      if(arr[i][attr]==value){
        index=i;
        break;
      }
    }
    arr.splice(index,1);
    arr = arr.map((item, index) => {
      item[attr] = index;
      return item;
    })
  },
  //日期转换
  dateFormat(val) {
    let date = new Date(val);
    let Y = date.getFullYear().toString();        // 年
    let m = (date.getMonth() + 1).toString();     // 月
    let d = date.getDate().toString();            // 日
    let H = date.getHours().toString();           // 时
    let M = date.getMinutes().toString();         // 分
    let S = date.getSeconds().toString();         // 秒
    m = m < 10 ? ("0" + m) : m;
    d = d < 10 ? ("0" + d) : d;
    return Y + "-" + m + "-" + d;
  },
  //日期格式转换：yyyyMMddhhmmss
  dateTimeFormat(val) {
    var date = new Date(val);
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hour=date.getHours();
    var minute=date.getMinutes();
    var second=date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
    }
    if (minute >= 0 && minute <= 9) {
        minute = "0" + minute;
    }
    if (second >= 0 && second <= 9) {
        second = "0" + second;
    }
    var dateFormat = `${date.getFullYear()} + ${month} + ${strDate} + ${hour} + ${minute} + ${second}`;
    return dateFormat;
  },
  // 文件流下载
  downloadFile(fileName, response) {
    // const disposition = response.headers['Content-Disposition'];
    // let fileName = disposition.substring(disposition.indexOf('filename=') + 9, disposition.length);
    // // iso8859-1的字符转换成中文
    // fileName = decodeURI(escape(fileName));
    // // 去掉双引号
    // fileName = fileName.replace(/\"/g, "");
    try {
      let href = window.URL.createObjectURL(response); //创建下载的链接
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE浏览器
        window.navigator.msSaveBlob(response, fileName);
      } else {
        var elink = document.createElement('a');
        elink.style.display = 'none';
        elink.download = fileName;
        elink.href = href;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    } catch (error) {

    }
  },
  getLaunchAreaLabelMap(launchAreaTree = []) {
    const labelMap = new Map();
    const traverse = (nodes = []) => {
      nodes.forEach(node => {
        labelMap.set(String(node.id), node.label);
        if (node.children && node.children.length) {
          traverse(node.children);
        }
      });
    };

    if (Array.isArray(launchAreaTree)) {
      traverse(launchAreaTree);
    }
    return labelMap;
  },
  collectLaunchAreaDisplayIds(node, checkedKeySet) {
    const children = Array.isArray(node.children) ? node.children : [];
    const nodeId = String(node.id);

    if (!children.length) {
      const isChecked = checkedKeySet.has(nodeId);
      return {
        fullyChecked: isChecked,
        ids: isChecked ? [node.id] : []
      };
    }

    const childResults = children.map(child => this.collectLaunchAreaDisplayIds(child, checkedKeySet));
    const allChildrenChecked = childResults.length > 0 && childResults.every(result => result.fullyChecked);

    if (allChildrenChecked) {
      return {
        fullyChecked: true,
        ids: [node.id]
      };
    }

    return {
      fullyChecked: false,
      ids: childResults.reduce((ids, result) => ids.concat(result.ids), [])
    };
  },
  getOutputLaunchDisplayIds(checkedKeys = [], launchAreaTree = []) {
    if (!Array.isArray(checkedKeys) || !checkedKeys.length) {
      return [];
    }

    if (!Array.isArray(launchAreaTree) || !launchAreaTree.length) {
      return checkedKeys;
    }

    const checkedKeySet = new Set(checkedKeys.map(key => String(key)));
    return launchAreaTree.reduce((ids, node) => {
      const result = this.collectLaunchAreaDisplayIds(node, checkedKeySet);
      return ids.concat(result.ids);
    }, []);
  },
  // 新文件下载
  newDownloadFile(fileId) {
    return new Promise(function(resolve, reject) {
      let fileUrl = `${baseCmrUrl}/v1/findFileExportInfo?id=${fileId}`;
      http.get(fileUrl).then(resp => {
        return resolve(resp.data)
      });
    })
  },
  // MaintainProductHierarchyList 查询导出字段
  maintainProductHierarchyList(flag, obj, tableColumnsList) {
    let params = {
      "accurateSelDto": {
        "barcode": obj.barcode,
        "itBarCode": obj.itbarcode,
        "itemCode": obj.itemCode,
        "productNameCn": obj.productNameCn,
        "productNameEn": obj.productNameEn,
        "selAll": obj.searchText,
        "swBarCode": obj.swbarcode,
        "variantCn": obj.cnvariant
      },
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize": flag === "export" ? '' : obj.pageSize,
      "selectMoreDto": {
        "brand": obj.brand,
        "brandElement": obj.brandElement,
        "brandForm": obj.brandForm,
        "brandSegment": obj.brandSegment,
        "category": obj.category,
        "itemStatus": obj.itemStatus,
        "itemType": obj.itemType,
        "localHierarchyFlags": obj.localHierarchyFlag,
        "sector": obj.sector,
        "subBrand": obj.subBrand,
        "subSector": obj.subSector 
      },
      "viewShow": tableColumnsList
    };
    return params;
  },
  // productLocalHierarchy 查询导出字段
  productLocalHierarchy(flag, obj, tableColumnsList) {
    let params = {
      accurateSelDto: {
        brandCode: obj.brandCode,
        categoryCode: obj.categoryCode,
        cnVariant: obj.variantCn,
        hierarchyStatus: obj.hierarchyStatus,
        newForm: "",
        priceTier: obj.priceTier,
        productFormCode: obj.productFormCode,
        pspNf: obj.pspNf,
        pspNfFlag: obj.pspNf,
        searchText: obj.searchText,
        subBrandCode: obj.subBrandCode,
        variantCode: obj.variantCode
      },
      pageNum: flag === "export" ? 1 : obj.pageNum,
      pageSize: flag === "export" ? '' : obj.pageSize,
      searchText: obj.searchText,
      viewShow: tableColumnsList
    };
    return params;
  },
  // productMasterData 查询导出字段
  productMasterData(flag, obj, tableColumnsList) {
    let params = {
      "accurateSelDto": {
        "cnVariant": obj.cnvariant,
        "itBarcode": obj.itbarcode,
        "itemBarcode": obj.barcode,
        "itemChineseDescription": obj.productNameCn,
        "itemCode": obj.itemCode,
        "itemEnglishDescription": obj.productNameEn,
        "swBarcode": obj.swbarcode,
        "selAll": obj.searchText,
        "hierarchyID":obj.hierarchyID
      },
      "masterDataMoreDTO": {
        "brandCode": obj.brandCode,
        "categoryCode": obj.categoryCode,
        "itemNature": obj.itemNature,
        "itemStatus": obj.itemStatus,
        "itemType": obj.itemType,
        "localHierarchyFlag": "",
        "localHierarchyFlags": obj.localHierarchyFlag,
        "productFormCode": obj.productFormCode,
        "pspnfFlag": obj.pspnfflag,
        "subBrandCode": obj.subBrandCode,
        "variantCode": obj.variantCode
      },
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize": flag === "export" ? '' : obj.pageSize,
      "viewShow": tableColumnsList
    };
    return params;
  },
  // powerSKUProductList 查询导出字段
  powerSKUProductList(flag, obj, tableColumnsList) {
    let params = {
      "barcode": obj.barcode,
      "brandCn": obj.brandCn,
      "brandCode": obj.brandCode,
      "brandEn": obj.brandEn,
      "categoryCn": obj.categoryCn,
      "categoryCode": obj.categoryCode,
      "categoryEn": obj.categoryEn,
      "channel": obj.channel,
      "groupID1": "",
      "groupID2": "",
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize": flag === "export" ? '' : obj.pageSize,
      "productFormCn": obj.productFormCn,
      "productFormCode": obj.productFormCode,
      "productFormEn": obj.productFormEn,
      "productNameCn": obj.productNameCn,
      "productNameEn": obj.productNameEn,
      "project": obj.project,
      "quarter": obj.quarter,
      "selectAll": obj.searchText,
      "storeType": obj.storeType,
      "subBrandCn": obj.subBrandCn,
      "subBrandCode": obj.subBrandCode,
      "subBrandEn": obj.subBrandEn,
      "variantCn": obj.variantCn,
      "variantCode": obj.variantCode,
      "variantEn": obj.variantEn,
      "viewShow": tableColumnsList.toString()
    };
    return params;
  },
  // pskuTargetList 查询导出字段
  pskuTargetList(flag, obj, tableColumnsList) {
    let params = {
      "categoryEn": obj.categoryEn,
      "channel": obj.channel,
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize":flag === "export" ? '' : obj.pageSize,
      "project": obj.project,
      "quarter": obj.quarter,
      "selectAll": obj.searchText,
      "selectProject": obj.project,
      "storeType": obj.storeType,
      "target1": obj.target1,
      "target2": obj.target2,
      "totalSize": 0,
      "viewShow": tableColumnsList.toString()
    };
    return params;
  },
  // customerMasterReportFull 查询导出字段
  customerMasterReportFull(flag, obj, tableColumnsList) {
    let params = {
      "banner": obj.banner,
      "bannerregion": obj.bannerregion,
      "billtoCode": obj.billtoCode,
      "billtoaccountgroup": obj.billtoaccountgroup,
      "billtoaddress": obj.billtoaddress,
      "billtocity": obj.billtocity,
      "billtocontact": obj.billtocontact,
      "billtogroupkey": obj.billtogroupkey,
      "billtopostalcode": obj.billtopostalcode,
      "billtoprovince": obj.billtoprovince,
      "billtotel": obj.billtotel,
      "channel": obj.channel,
      "csremail": obj.csremail,
      "csrname": obj.csrname,
      "customerclassification": obj.customerclassification,
      "customergroup": obj.customergroup,
      "customergroup5": obj.customergroup5,
      "division": obj.division,
      "ecombanner": obj.ecombanner,
      "fdccode": obj.fdccode,
      "market": obj.market,
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize":flag === "export" ? '' : obj.pageSize,
      "payerCode": obj.payerCode,
      "payeraccountgroup": obj.payeraccountgroup,
      "payerbankmemo": obj.payerbankmemo,
      "payergroupkey": obj.payergroupkey,
      "paytoCode": obj.paytoCode,
      "paytoaccountgroup": obj.paytoaccountgroup,
      "paytobankaccount": obj.paytobankaccount,
      "paytobankkey": obj.paytobankkey,
      "paytobankname": obj.paytobankname,
      "paytocity": obj.paytocity,
      "paytoemail": obj.paytoemail,
      "paytofax": obj.paytofax,
      "paytonamecn": obj.paytonamecn,
      "paytopostalcode": obj.paytopostalcode,
      "paytoprovince": obj.paytoprovince,
      "paytostatus": obj.paytostatus,
      "paytotel": obj.paytotel,
      "rdccode": obj.rdccode,
      "salesArea": obj.salesArea,
      "searchText": obj.searchText,
      "shiptoCode": obj.shiptoCode,
      "shiptoStatus": obj.shiptoStatus,
      "shiptoaccountgroup": obj.shiptoaccountgroup,
      "shiptoaddress": obj.shiptoaddress,
      "shiptocity": obj.shiptocity,
      "shiptodc": obj.shiptodc,
      "shiptogroupkey": obj.shiptogroupkey,
      "shiptopostalcode": obj.shiptopostalcode,
      "shiptoprovince": obj.shiptoprovince,
      "shiptoreceiver": obj.shiptoreceiver,
      "shiptosubtype": obj.shiptosubtype,
      "shiptotel": obj.shiptotel,
      "shiptotype": obj.shiptotype,
      "shiptovendorcode": obj.shiptovendorcode,
      "soldtoCode": obj.soldtoCode,
      "soldtoNameCn": obj.soldtoNameCn,
      "soldtoNameEn": obj.soldtoNameEn,
      "soldtoStatus": obj.soldtoStatus,
      "soldtoaccountgroup": obj.soldtoaccountgroup,
      "soldtoaddress": obj.soldtoaddress,
      "soldtocity": obj.soldtocity,
      "soldtodc": obj.soldtodc,
      "soldtofax": obj.soldtofax,
      "soldtogroupkey": obj.soldtogroupkey,
      "soldtopaymentterm": obj.soldtopaymentterm,
      "soldtopostalcode": obj.soldtopostalcode,
      "soldtoprovince": obj.soldtoprovince,
      "soldtotel": obj.soldtotel,
      "soldtovatregno": obj.soldtovatregno,
      "tzonecode": obj.tzonecode,
      "reportFlag": obj.reportFlag ? obj.reportFlag : '',
      "viewShow": tableColumnsList.toString()
    };
    return params;
  },
  // iomnoStoreNOCReport 查询导出字段
  iomnoStoreNOCReport(flag, obj, tableColumnsList) {
    let params = {
      "banner": "string",
      "cc": 0,
      "club": 0,
      "cvs": 0,
      "ds": 0,
      "ecom": 0,
      "hm": 0,
      "largeMini": 0,
      "largeSM": 0,
      "others": 0,
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize":flag === "export" ? '' : obj.pageSize,
      "pcs": 0,
      "premiumSM": 0,
      "prestigeSM": 0,
      "searchStatus": "",
      "searchText": "",
      "smallMini": 0,
      "smallSM": 0,
      "total": 0,
      "viewShow": tableColumnsList
    };
    return params;
  },
   // seoCoverage 查询导出字段
   seoCoverage(flag, obj, tableColumnsList) {
    let params = {
      "marketOrUnit": obj.hubOrganization,
      "pageNum": flag === "export" ? 1 : obj.pageNum,
      "pageSize":flag === "export" ? '' : obj.pageSize,
      "role": obj.role,
      "searchStatus": "",
      "searchText": obj.searchText,
      "uid": "",
      "viewShow": tableColumnsList
    };
    return params;
  },
  // reportCenter的form表单字段共同
  reportCenterForm() {
    let queryFilter = {
      itemStatus: '',
      itemNature: '',
      pspnfflag: '',
      localHierarchyFlag: [],
      category: '',
      categoryCode: '',
      categoryCn: '',
      categoryEn: '',
      categoryID: '',
      productNameCn: '',
      productNameEn: '',
      productForm: '',
      productFormCn: '',
      productFormCode: '',
      productFormEn: '',
      productFormID: '',
      brand: '',
      brandCode: '',
      brandCn: '',
      brandEn: '',
      brandID: '',
      subBrand: '',
      subBrandCode: '',
      subBrandCn: '',
      subBrandEn: '',
      subBrandID: '',
      variant: '',
      variantCode: '',
      variantCn: '',
      variantEn: '',
      variantID: '',
      cnVariant: '',
      itemCode: '',
      barcode: '',
      itbarcode: '',
      swbarcode: '',
      itemType: '',
      searchScope: '0',
      searchKeyword: '',
      searchText: '',

      cacheKey: '',

      pspNf: '',
      hierarchyStatus: '',
      priceTier: '',

      storeType: '',
      channel: '',
      quarter: '',
      project: '',

      selectProject: '',
      target1: '',
      target2: '',

      banner: '',
      bannerregion: '',
      billtoCode: '',
      billtoaccountgroup: '',
      billtoaddress: '',
      billtocity: '',
      billtocontact: '',
      billtogroupkey: '',
      billtopostalcode: '',
      billtoprovince: '',
      billtotel: '',
      csremail: '',
      csrname: '',
      customerclassification: '',
      customergroup: '',
      customergroup5: '',
      division: '',
      ecombanner: '',
      fdccode: '',
      market: '',
      payerCode: '',
      payeraccountgroup: '',
      payerbankmemo: '',
      payergroupkey: '',
      paytoCode: '',
      paytoaccountgroup: '',
      paytobankaccount: '',
      paytobankkey: '',
      paytobankname: '',
      paytocity: '',
      paytoemail: '',
      paytofax: '',
      paytonamecn: '',
      paytopostalcode: '',
      paytoprovince: '',
      paytostatus: '',
      paytotel: '',
      rdccode: '',
      salesArea: '',
      shiptoCode: '',
      shiptoStatus: '',
      shiptoaccountgroup: '',
      shiptoaddress: '',
      shiptocity: '',
      shiptodc: '',
      shiptogroupkey: '',
      shiptopostalcode: '',
      shiptoprovince: '',
      shiptoreceiver: '',
      shiptosubtype: '',
      shiptotel: '',
      shiptotype: '',
      shiptovendorcode: '',
      soldtoCode: '',
      soldtoNameCn: '',
      soldtoNameEn: '',
      soldtoStatus: '',
      soldtoaccountgroup: '',
      soldtoaddress: '',
      soldtocity: '',
      soldtodc: '',
      soldtofax: '',
      soldtogroupkey: '',
      soldtopaymentterm: '',
      soldtopostalcode: '',
      soldtoprovince: '',
      soldtotel: '',
      soldtovatregno: '',
      tzonecode: ''
    };
    return queryFilter;
  },
  // 静态枚举数据
  reportCenterList(flag) {
    let obj = {
      itemStatusList: [
        {
            "option_value": "1",
            "option_label": "Under Planning"
        },
        {
            "option_value": "2",
            "option_label": "Advance Order"
        },
        {
            "option_value": "3",
            "option_label": "Active"
        },
        {
            "option_value": "4",
            "option_label": "Discontinued"
        },
        {
            "option_value": "5",
            "option_label": "Inactive"
        }
      ],
      itemNatureList: [
        {
            "option_value": "1",
            "option_label": "Normal Pack"
        },
        {
            "option_value": "2",
            "option_label": "Promotion Pack"
        },
        {
            "option_value": "3",
            "option_label": "C&C Bundle Pack"
        },
        {
            "option_value": "4",
            "option_label": "Component"
        },
      ],
      p_sp_nf_FlagList: [
        {
            "option_value": "0",
            "option_label": "Y"
        },
        {
            "option_value": "1",
            "option_label": "N"
        }
      ],
      localHierarchyFlagList: [
        {
            "option_value": "Y",
            "option_label": "Y"
        },
        {
            "option_value": "N",
            "option_label": "N"
        },
        {
            "option_value": "New Product",
            "option_label": "New Product"
        },
        {
            "option_value": "Need add Local Hierarchy",
            "option_label": "Need add Local Hierarchy"
        }
      ],
      itemTypeList: [
        {
            "option_value": "CN",
            "option_label": "CN"
        },
        {
            "option_value": "CN/HK",
            "option_label": "CN/HK"
        }
      ],
      hierarchyStatusList: [
        {
            "option_value": "Active",
            "option_label": "Active"
        },
        {
            "option_value": "Inactive",
            "option_label": "Inactive"
        }
      ],
      p_SP_NFList: [
        {
            "option_value": "Y",
            "option_label": "Y"
        },
        {
            "option_value": "N",
            "option_label": "N"
        },
      ],
      priceTierList: [
        {
          "option_value": "Super Premium",
          "option_label": "Super Premium"
        },
        {
            "option_value": "Premium",
            "option_label": "Premium"
        },
        {
          "option_value": "High",
          "option_label": "High"
        },
        {
          "option_value": "Mid",
          "option_label": "Mid"
        },
        {
          "option_value": "Value",
          "option_label": "Value"
        },
      ],
      storeTypeList: [
        {
            "option_value": "1",
            "option_label": "HM"
        },
        {
            "option_value": "2",
            "option_label": "C&C"
        },
        {
            "option_value": "3",
            "option_label": "Club"
        },
        {
            "option_value": "4",
            "option_label": "LMM"
        },
        {
            "option_value": "5",
            "option_label": "SMM"
        },
        {
            "option_value": "6",
            "option_label": "PCS"
        },
        {
            "option_value": "7",
            "option_label": "CVS"
        },
        {
            "option_value": "8",
            "option_label": "DS"
        },
        {
            "option_value": "9",
            "option_label": "eCOM"
        },
        {
            "option_value": "10",
            "option_label": "Others (WS,virtual…)"
        },
        {
            "option_value": "11",
            "option_label": "Large Super"
        },
        {
            "option_value": "12",
            "option_label": "Small Super"
        },
        {
            "option_value": "13",
            "option_label": "Premium Super"
        },
        {
            "option_value": "14",
            "option_label": "Prestige Super"
        },
        {
            "option_value": "15",
            "option_label": "SM-E"
        },
        {
            "option_value": "16",
            "option_label": "SM-S"
        },
        {
            "option_value": "17",
            "option_label": "SM-W"
        },
        {
            "option_value": "18",
            "option_label": "SM-N"
        },
        {
            "option_value": "19",
            "option_label": "PLBB"
        },
        {
            "option_value": "20",
            "option_label": "LBB"
        },
        {
            "option_value": "21",
            "option_label": "SBB"
        },
        {
            "option_value": "22",
            "option_label": "LBT"
        },
        {
            "option_value": "23",
            "option_label": "SBT"
        },
        {
            "option_value": "24",
            "option_label": "LT"
        },
        {
            "option_value": "25",
            "option_label": "MT"
        },
        {
            "option_value": "26",
            "option_label": "ST"
        },
        {
            "option_value": "27",
            "option_label": "Pharmacy"
        },
        {
            "option_value": "28",
            "option_label": "WS"
        },
        {
            "option_value": "29",
            "option_label": "PWS"
        },
        {
            "option_value": "30",
            "option_label": "DC"
        }
      ],
      channelList: [
        {
            "option_value": "D-Partner",
            "option_label": "D-Partner"
        },
        {
            "option_value": "D-Partner C",
            "option_label": "D-Partner C"
        },
        {
            "option_value": "D-Partner N",
            "option_label": "D-Partner N"
        },
        {
            "option_value": "D-Partner SE",
            "option_label": "D-Partner SE"
        },
        {
            "option_value": "DMC-E",
            "option_label": "DMC-E"
        },
        {
            "option_value": "iOMNI O&O",
            "option_label": "iOMNI O&O"
        },
        {
            "option_value": "D5-RR",
            "option_label": "D5-RR"
        },
      ],
      quarterList: [
        {
            "option_value": "1",
            "option_label": "AMJ21"
        },
        {
            "option_value": "2",
            "option_label": "JFM21"
        },
        {
            "option_value": "3",
            "option_label": "OND20"
        },
        {
            "option_value": "4",
            "option_label": "JAS20"
        },
        {
            "option_value": "5",
            "option_label": "AMJ20"
        },
        {
            "option_value": "6",
            "option_label": "JFM20"
        },
        {
            "option_value": "7",
            "option_label": "OND19"
        },
        {
            "option_value": "8",
            "option_label": "JAS19"
        },
        {
            "option_value": "9",
            "option_label": "AMJ19"
        },
        {
            "option_value": "10",
            "option_label": "JFM19"
        },
        {
            "option_value": "11",
            "option_label": "OND18"
        },
        {
            "option_value": "12",
            "option_label": "JAS18"
        },
        {
            "option_value": "13",
            "option_label": "AMJ18"
        },
      ],
      soldToStatusList: [
        {
            "option_value": "1",
            "option_label": "Active"
        },
        {
            "option_value": "2",
            "option_label": "Inactive"
        }
      ],
      shipToStatusList: [
        {
            "option_value": "1",
            "option_label": "Active"
        },
        {
            "option_value": "2",
            "option_label": "Inactive"
        },
        {
            "option_value": "3",
            "option_label": "Dummy"
        }
      ],
      salesAreaList: [
        {
            "option_value": "1",
            "option_label": "Home Product"
        },
        {
            "option_value": "2",
            "option_label": "Cosmetic"
        },
        {
            "option_value": "3",
            "option_label": "DSTC"
        }
      ],
      channelList1: [
        {
            "option_value": "1",
            "option_label": "D-Partner"
        },
        {
            "option_value": "2",
            "option_label": "BRAUN"
        },
        {
            "option_value": "3",
            "option_label": "SCW"
        },
        {
            "option_value": "4",
            "option_label": "DSC"
        },
        {
            "option_value": "5",
            "option_label": "iOMNI O&O"
        },
        {
            "option_value": "6",
            "option_label": "iOMNI eCom"
        },
        {
            "option_value": "7",
            "option_label": "D5-RR"
        },
        {
            "option_value": "8",
            "option_label": "Others"
        }
      ]
    };
    return obj;
  },
  // My Responsibility Edit Submit
  responsibilityEdit(obj, getEmployeeTicketList) {
    if(getEmployeeTicketList.length > 0) {
      getEmployeeTicketList.forEach(item => {
        item.rpobrc.defaultRole = item.rpobrc.defaultRole ? 1 : 0;
        item.rpobrc.categoryId = typeof item.rpobrc.categoryId === 'string' ? item.rpobrc.categoryId.split(',') : item.rpobrc.categoryId ? item.rpobrc.categoryId : [];
        item.rpobrc.category2Id = typeof item.rpobrc.category2Id === 'string' ? item.rpobrc.category2Id.split(',') : item.rpobrc.category2Id ? item.rpobrc.category2Id : [];
        item.rpobrc.servingORG = typeof item.rpobrc.servingORG === 'string' ? item.rpobrc.servingORG.split(',') : item.rpobrc.servingORG ? item.rpobrc.servingORG : [];
        item.rpobrc.servingBannerRD = typeof item.rpobrc.servingBannerRD === 'string' ? item.rpobrc.servingBannerRD.split(',') : item.rpobrc.servingBannerRD ? item.rpobrc.servingBannerRD : [];
        item.rpobrc.servingRDC = typeof item.rpobrc.servingRDC === 'string' ? item.rpobrc.servingRDC.split(',') : item.rpobrc.servingRDC ? item.rpobrc.servingRDC : [];
        item.rpobrc.servingShipto = typeof item.rpobrc.servingShipto === 'string' ? item.rpobrc.servingShipto.split(',') : item.rpobrc.servingShipto ? item.rpobrc.servingShipto : [];
      })
    };
    let params = {
      "employee": {
        "address1": null,
        "comment": obj.comment,
        "contactId": null,
        "gender": null,
        "geoBoundaryId": null,
        "location": null,
        "mobilePhone": null,
        "nameCn": null,
        "partyRole": obj.partyRole,
        "postalCode": null,
        "rpobrc": null,
        "rpobrclist": obj.responsibilityList,
        "sapNumber": null,
        "ticketId": null,
        "uid": obj.uid,
        "workEffort": null
      },
      "nameEn": obj.uid,
      "responsibility": getEmployeeTicketList.length > 0 ? getEmployeeTicketList : null,
      "uid": obj.uid,
      "userName": null
    };
    return params;
  },
  responsibilityEditConfirm(obj, getEmployeeTicketList) {
    if(getEmployeeTicketList.length > 0) {
      getEmployeeTicketList.forEach(item => {
        item.rpobrc.defaultRole = item.rpobrc.defaultRole ? 1 : 0;
        item.rpobrc.categoryId = typeof item.rpobrc.categoryId === 'string' ? item.rpobrc.categoryId.split(',') : item.rpobrc.categoryId ? item.rpobrc.categoryId : [];
        item.rpobrc.category2Id = typeof item.rpobrc.category2Id === 'string' ? item.rpobrc.category2Id.split(',') : item.rpobrc.category2Id ? item.rpobrc.category2Id : [];
        item.rpobrc.servingORG = typeof item.rpobrc.servingORG === 'string' ? item.rpobrc.servingORG.split(',') : item.rpobrc.servingORG ? item.rpobrc.servingORG : [];
        item.rpobrc.servingBannerRD = typeof item.rpobrc.servingBannerRD === 'string' ? item.rpobrc.servingBannerRD.split(',') : item.rpobrc.servingBannerRD ? item.rpobrc.servingBannerRD : [];
        item.rpobrc.servingRDC = typeof item.rpobrc.servingRDC === 'string' ? item.rpobrc.servingRDC.split(',') : item.rpobrc.servingRDC ? item.rpobrc.servingRDC : [];
        item.rpobrc.servingShipto = typeof item.rpobrc.servingShipto === 'string' ? item.rpobrc.servingShipto.split(',') : item.rpobrc.servingShipto ? item.rpobrc.servingShipto : [];
      })
    };
    let params = {
      "employee": {
        "address1": null,
        "comment": obj.comment,
        "contactId": null,
        "gender": null,
        "geoBoundaryId": null,
        "location": null,
        "mobilePhone": null,
        "nameCn": null,
        "partyRole": obj.partyRole,
        "postalCode": null,
        "rpobrc": null,
        "rpobrclist": obj.responsibilityList,
        "sapNumber": null,
        "ticketId": null,
        "uid": obj.uid,
        "workEffort": null
      },
      "nameEn": obj.uid,
      "responsibility": getEmployeeTicketList,
      "uid": obj.uid,
      "userName": null
    };
    return params;
  }
}
export default cmr;
Vue.prototype.cmrJs = cmr;




// WEBPACK FOOTER //
// ./src/util/cmr.js